import { useNavigate } from "react-router-dom";
export function SidebarLogoShort() {
  const history = useNavigate();
  return (
    <img
      src={require("../../assets/EKFCShortLogo.png")}
      alt="logo"
      style={{ height: "25px" }}
      onClick={() => history("/")}
    />
  );
}
